<div class="maintenance-container d-flex align-items-center justify-content-center">
  <div class="text-center p-4">
    <img src="assets/img/logo.svg" alt="logo" class="mb-4" height="60">
    <h1 class="mb-3">Revenim în curând!</h1>
    <p class="lead mb-4">
      Efectuăm o actualizare a aplicației pentru a-ți oferi o experiență îmbunătățită.
    </p>
    <p class="text-muted">
      Îți mulțumim pentru răbdare și înțelegere. Ne vedem imediat!
    </p>
    <div class="spinner-border text-primary mt-4" role="status">
      <span class="visually-hidden">Se încarcă...</span>
    </div>
  </div>
</div>
